var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 15.5V5.3125L6 8.5625L4.25 6.75L10.5 0.5L16.75 6.75L15 8.5625L11.75 5.3125V15.5H9.25ZM3 20.5C2.3125 20.5 1.72396 20.2552 1.23438 19.7656C0.744792 19.276 0.5 18.6875 0.5 18V14.25H3V18H18V14.25H20.5V18C20.5 18.6875 20.2552 19.276 19.7656 19.7656C19.276 20.2552 18.6875 20.5 18 20.5H3Z",
    fill: "#49A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityUploadIcon);
export default __webpack_public_path__ + "static/media/SecurityUploadIcon.f6e7bb88e510a3222aadc60c84bcda5c.svg";
export { ForwardRef as ReactComponent };